import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import DesignOrders from './components/DesignOrders';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
const isDesignOrdersRoute = window.location.pathname.replace(/\/+$/, '') === '/design-orders';

root.render(
  <React.StrictMode>
    {isDesignOrdersRoute ? <DesignOrders /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
